import env from "dotenv";
Vue.use(env);
import Vue from "vue";
import App from "./App.vue";
import './ant';
import "font-awesome/css/font-awesome.css";
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

import store from "./store/index.js";
import router from "./router/index.js";
import filters from './filters';
import moment from "moment";
import _ from "underscore";

import localforage from 'localforage';
localforage.config({
    driver: localforage.LOCALSTORAGE,
    storeName: 'wemail'
});
import "flag-icon-css/css/flag-icon.css";

/**
 * Vue Overlay loader plugin
 */
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);
Vue.use(Donut);

store.dispatch('auth/fetchUser').catch(() => {
    store.dispatch('auth/clearAuth')
    router.replace({ name: 'login' })
})

Vue.config.productionTip = false;

Vue.prototype.$weNotify = function(type, message) {
	this.$notification[type]({
		message: message
	});
};

filters.forEach(f => {
	Vue.filter(f.name, f.execute);
});

Vue.mixin({
    methods: {
        // Format the given date with respect to timezone.
        formatDate(unixTime){
            return moment(unixTime * 1000).add(new Date().getTimezoneOffset() / 60)
        },

        // Extract the job base name.
        jobBaseName(name){
            if (!name.includes('\\')) return name;

            var parts = name.split("\\");

            return parts[parts.length - 1];
        },

        // Convert to human readable timestamp.
        readableTimestamp(timestamp){
            return this.formatDate(timestamp).format('YY-MM-DD HH:mm:ss');
        },

        // Format the tags.
        displayableTagsList(tags, truncate = true){
            if (!tags || !tags.length) return '';

            return _.reduce(tags, (s, n)=> {
                const str = (truncate && n.length > 35) ? (n.substring(0, 32) + '...') : n;
                return (s ? s + ', ' : '') + str;
            }, '');
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
});

new Vue({
    store,
	router,
    watch: {
        $route(to, from) {
            if (to || from)
                document.title = to.meta.title ? `${to.meta.title} - WeMail` : 'WeMail';
        }
    },
	render: h => h(App)
}).$mount("#app");
